import { render, staticRenderFns } from "./SelectPosting.vue?vue&type=template&id=717f5831&"
import script from "./SelectPosting.vue?vue&type=script&lang=ts&"
export * from "./SelectPosting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717f5831')) {
      api.createRecord('717f5831', component.options)
    } else {
      api.reload('717f5831', component.options)
    }
    module.hot.accept("./SelectPosting.vue?vue&type=template&id=717f5831&", function () {
      api.rerender('717f5831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/custom/select/SelectPosting.vue"
export default component.exports